import { TCreateVideoAction, CreateVideoActionTypes } from './createVideoActions';
import { ICreateVideoState } from './createVideoContext';

export const createVideoReducer = (state: ICreateVideoState, action: TCreateVideoAction): ICreateVideoState => {
	switch (action.type) {
		case CreateVideoActionTypes.CHANGE_VISIBLE_FORM:
			return {
				...state,
				visibleForm: action.payload.visibleForm,
			};
		case CreateVideoActionTypes.SET_FILE_ID:
			return {
				...state,
				fileId: action.payload.fileId,
			};
		case CreateVideoActionTypes.SET_FETCHED_STUDIOS:
			return {
				...state,
				fetchedStudios: action.payload.fetchedStudios,
			};
		case CreateVideoActionTypes.SET_ID_STUDIO:
			return {
				...state,
				IDSelectedStudio: action.payload.IDSelectedStudio,
			};
		case CreateVideoActionTypes.REFETCH_STUDIOS:
			return {
				...state,
				needRefetchStudios: action.payload.needRefetchStudios,
			};
		case CreateVideoActionTypes.CHANGE_NAME_OF_VIDEO:
			return {
				...state,
				nameOfVideo: action.payload.nameOfVideo,
			};
		case CreateVideoActionTypes.SET_FETCHED_CATEGORIES:
			return {
				...state,
				fetchedCategories: action.payload.fetchedCategories,
			};
		case CreateVideoActionTypes.SET_ID_CATEGORY:
			return {
				...state,
				IDSelectedCategory: action.payload.IDSelectedCategory,
			};
		case CreateVideoActionTypes.CHANGE_FILE_DATA:
			return {
				...state,
				fileData: action.payload.fileData,
			};
		case CreateVideoActionTypes.SET_FETCHED_LANGUAGES:
			return {
				...state,
				fetchedLanguages: action.payload.fetchedLanguages,
			};
		case CreateVideoActionTypes.SET_IDs_LANGUAGES:
			return {
				...state,
				IDsSelectedLanguages: action.payload.IDsSelectedLanguages,
			};
		case CreateVideoActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case CreateVideoActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.translations,
			};
		case CreateVideoActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case CreateVideoActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateVideoActionTypes.RESET_FIELDS:
			return {
				...state,
				visibleForm: 'mainForm',
				fileId: null,
				sourceUrlLocally: null,
				IDSelectedStudio: null,
				needRefetchStudios: false,
				nameOfVideo: '',
				IDSelectedCategory: null,
				fileData: {
					fileId: '',
					fileHash: null,
					fileName: null,
				},
				IDsSelectedLanguages: [],
				selectedTranslationTab: null,
				translations: [],
				dataForSubmit: null,
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
